// src/pages/Portfolio.js
import { FiExternalLink } from 'react-icons/fi';
import FadeIn from '../components/FadeIn';
import { usePortfolio } from '../hooks/usePortfolio';

function Portfolio() {
  const { portfolio, loading } = usePortfolio();

  return (
    <div className="portfolio-page">
      <section className="portfolio-hero">
        <FadeIn>
          <p className="offer-heading">Our Work</p>
          <h1 className="services-hero-title">Portfolio</h1>
          <p className="services-hero-body">
            A selection of websites we've built for our clients.
          </p>
        </FadeIn>
      </section>

      <section className="portfolio-grid-section">
        {loading && <p style={{ textAlign: 'center', padding: '2rem' }}>Loading…</p>}

        {!loading && portfolio.length === 0 && (
          <FadeIn>
            <div className="portfolio-empty">
              <h2>Coming Soon</h2>
              <p>We're currently building out our portfolio. Check back soon!</p>
            </div>
          </FadeIn>
        )}

        {!loading && portfolio.length > 0 && (
          <div className="portfolio-grid">
            {portfolio.map((item, i) => (
              <FadeIn key={item.id} delay={i * 100}>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="portfolio-card"
                >
                  {item.imageUrl && (
                    <div className="portfolio-card-image">
                      <img src={item.imageUrl} alt={item.title} />
                    </div>
                  )}
                  <div className="portfolio-card-body">
                    <h3 className="portfolio-card-title">
                      {item.title} <FiExternalLink size={14} />
                    </h3>
                    {item.description && (
                      <p className="portfolio-card-desc">{item.description}</p>
                    )}
                  </div>
                </a>
              </FadeIn>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default Portfolio;
